/* Rename this file to desktop-init or similar. */
var bLazy;

$( document ).ready(function() {
        bLazy = new Blazy({selector: ".b-lazy", success: function() { bLazy.revalidate() }});
});